import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect () {
    //console.log("Connected crop");
    //this.cropme = new Cropme(this.element);
  }
}
